var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home"},[_c('SiteHeader'),_c('main',{staticClass:"home__body"},[_c('HomeContent')],1),_c('TemplateFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }